import React, { PureComponent } from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
  ReferenceLine
} from "recharts";
import { map, memoize } from "lodash";
import { pure } from "recompose";

import Teams from "api/Teams";
import CustomLabel from "./custom-label";
import TooltipContent from "./tooltip-content";
import Auth from "../../routes/Auth";

const getCurrentToken = () => {
  return Auth.getToken();
};

const getCurrentCourseId = () => {
  return Auth.getCourseId();
};

const getCurrentUserId = () => {
  return Auth.getUserId();
};

const tickFormatter = memoize((suffix, precision) => value =>
  `${value.toFixed(precision)}${suffix}`
);

const customLabel = props => {
  const { value, x, y, height } = props;
  const obj = JSON.parse(value);
  return obj.value >= 0 ? (
    <text
      x={x - 5}
      y={y + height / 2}
      fill="#000"
      dominantBaseline="middle"
      textAnchor="end"
    >
      {obj.name}
    </text>
  ) : (
    <text
      x={x + 5}
      y={y + height / 2}
      fill="#000"
      dominantBaseline="middle"
      textAnchor="start"
    >
      {obj.name}
    </text>
  );
};

//FIXME make proper ticks (not used for now as x ticks are hidden)
const getTicks = (min, max) => {
  return min <= 0 && max >= 0
    ? { ticks: [-1, 0, 1], tickPrecision: 0 }
    : { ticks: [0, 1, 2], tickPrecision: 0 };
};

class CustomXAxisLabel extends PureComponent {
  render() {
    const { x, y, value, height, instructorData } = this.props;
    const payload = JSON.parse(value);
    let additionalOffset = payload.name.length - 1;
    if (additionalOffset < 0) {
      additionalOffset = 0;
    }

    return (
      <g transform={`translate(${x - 5},${y + height / 2})`}>
        <text
          x={0}
          y={0}
          dx={payload.value >= 0 ? 0 : 10}
          textAnchor={payload.value >= 0 ? "end" : "start"}
          dominantBaseline="middle"
          fill="#666"
        >
          {payload.name}
        </text>
        <a
          href={`/analysis/team-reports/grades-ranks/${instructorData.type
            }?team_id=${payload.id}&round_number=${instructorData.roundNumber
            }&game_id=${instructorData.currentGame
            }&_token=${getCurrentToken()}&_userid=${getCurrentUserId()}&_courseid=${getCurrentCourseId()}&_target=blank`}
          target="_blank"
          rel="noreferrer"
        >
          <text
            x={0}
            y={0}
            dx={
              payload.value >= 0
                ? -15 - additionalOffset * 5
                : 25 + additionalOffset * 5
            }
            textAnchor={payload.value >= 0 ? "end" : "start"}
            dominantBaseline="middle"
            fill="#666"
          >
            View
          </text>
        </a>
      </g>
    );
  }
}

const VerticalBar = pure(
  ({
    prefix = "",
    suffix = "",
    precision = 2,
    data = [],
    hideNames = false,
    xAxisLine = true,
    yAxisLine = true,
    xTick = true,
    yTick = true,
    xTickLine = true,
    yTickLine = false,
    customColors = null,
    showCategoryLabels = false,
    instructorData = null,
    teams = null
  }) => {
    const dataModded = map(data, item => ({
      ...item,
      all: JSON.stringify(item)
    }));
    let min = Math.min.apply(null, map(data, "value"));
    let max = Math.max.apply(null, map(data, "value"));

    if (min === 0 && max === 0) {
      min = -10;
      max = 10;
    } else {
      min = min < 0 ? min : 0;
    }

    const span = max - min;
    const delta = span * 0.5;
    const domain = [min - delta / 2, max + delta / 2];
    const colors = customColors ? customColors : Teams.competitiveColors(teams);
    const { ticks, tickPrecision } = getTicks(domain[0], domain[1]);

    return (
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={dataModded} barSize={18} layout="vertical">
          <XAxis
            type="number"
            dataKey="value"
            domain={domain}
            axisLine={xAxisLine}
            tick={xTick}
            tickLine={xTickLine}
            tickFormatter={tickFormatter(suffix, tickPrecision)}
            ticks={ticks}
            hide={true}
          />
          <YAxis
            type="category"
            dataKey="name"
            hide={true}
            axisLine={yAxisLine}
            tick={yTick}
            tickLine={yTickLine}
          />
          <Tooltip
            content={<TooltipContent prefix={prefix} suffix={suffix} />}
          />
          <ReferenceLine x={0} stroke="#000" />
          <Bar
            dataKey="value"
            minPointSize={5}
            isAnimationActive={!showCategoryLabels}
            label={
              <CustomLabel
                prefix={prefix}
                precision={precision}
                suffix={suffix}
                layout="vertical"
              />
            }
          >
            <LabelList
              dataKey="all"
              content={
                instructorData ? (
                  <CustomXAxisLabel instructorData={instructorData} />
                ) : (
                  customLabel
                )
              }
            />
            {colors.map((color, i) => (
              <Cell key={i} fill={color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  }
);

export default VerticalBar;



// WEBPACK FOOTER //
// ./src/components/analysis/vertical-bar.js